import React from 'react';
import fileDownload from 'js-file-download';

import { Button } from 'react-bootstrap';
import { FaCog } from 'react-icons/fa';

import api from 'api';
import useFeedback from 'hooks/useFeedback';

interface ExportListButtonProps {
  requestParams?: Record<string, any>;
}

const ExportListButton: React.FC<ExportListButtonProps> = ({ requestParams }) => {
  const { setError } = useFeedback();
  const [downloading, setDownloading] = React.useState(false);

  const onExport = React.useCallback(() => {
    setDownloading(true);
    api
      .getAdminOverviewDownload(requestParams)
      .then(({ data }) => {
        fileDownload(data, 'VerificationAdministrator.csv');
      })
      .catch(() => setError('Error exporting file'))
      .finally(() => setDownloading(false));
  }, [requestParams, setError]);

  return (
    <Button variant="secondary" onClick={onExport} disabled={downloading}>
      {downloading ? <FaCog className="fa-spin" /> : 'Export'}
    </Button>
  );
};

export default ExportListButton;
